import { render, staticRenderFns } from "./RecoverPassFormConfirm.vue?vue&type=template&id=41f07d4b&scoped=true&"
import script from "./RecoverPassFormConfirm.vue?vue&type=script&lang=js&"
export * from "./RecoverPassFormConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPassFormConfirm.vue?vue&type=style&index=0&id=41f07d4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f07d4b",
  null
  
)

export default component.exports